module.exports = __webpack_public_path__ + "static/media/SuccessfullyCreatedCompany.f63e1353.svg";